import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dv-battery",
  "use": "dv-battery-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"dv-battery\"><defs><style>#dv-battery .cls-1{fill:#fff1de;fill-opacity:0}</style></defs><title>资源 23</title><g id=\"dv-battery_图层_2\" data-name=\"图层 2\"><g id=\"dv-battery_图层_1-2\" data-name=\"图层 1\"><path id=\"dv-battery_矩形_266\" data-name=\"矩形 266\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><path id=\"dv-battery_形状结合\" d=\"M2.81 20.47a1.31 1.31 0 0 1-1.31-1.31V7.83a1.31 1.31 0 0 1 1.31-1.31h18.38a1.31 1.31 0 0 1 1.31 1.31v11.33a1.31 1.31 0 0 1-1.31 1.31zM15.5 14h1.75v1.5h1.17V14h1.75v-1h-1.75v-1.5h-1.17V13H15.5zM3.83 14H8.5v-1H3.83zM15.5 5.52V4.18a.65.65 0 0 1 .66-.65h3.35a.66.66 0 0 1 .66.65v1.34zm-11.67 0V4.18a.66.66 0 0 1 .66-.65h3.35a.65.65 0 0 1 .66.65v1.34z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dv-battery.svg
// module id = y5gH
// module chunks = 6